"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openNotif = exports.unknownError = exports.success = exports.successNotif = exports.errNotif = exports.errorNotif = exports.infoNotif = exports.notify = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bridge = require("./bridge");

var _notification_context = require("./notification_context");

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // NotificationFunctions.js


var notify = function notify(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 3.5 : _ref$duration,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["duration", "type"]);

  var params = _extends({ duration: duration }, rest);
  switch (type) {
    case "succes":
      return successNotif(params);
    case "error":
      return errorNotif(params);
    case "info":
      return infoNotif(params);
    default:
      return (0, _notification_context.addNotif)(params);
  }
};

exports.notify = notify;
var infoNotif = function infoNotif(_ref2) {
  var _ref2$duration = _ref2.duration,
      duration = _ref2$duration === undefined ? 5 : _ref2$duration,
      rest = _objectWithoutProperties(_ref2, ["duration"]);

  return (0, _notification_context.addNotif)(_extends({
    duration: duration,
    baseColor: "blue"
  }, rest));
};

exports.infoNotif = infoNotif;
var errorNotif = function errorNotif(_ref3) {
  var _ref3$title = _ref3.title,
      title = _ref3$title === undefined ? (0, _bridge.t)("oops") : _ref3$title,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === undefined ? 5 : _ref3$duration,
      rest = _objectWithoutProperties(_ref3, ["title", "duration"]);

  return (0, _notification_context.addNotif)(_extends({
    title: title,
    baseColor: "red",
    duration: duration
  }, rest));
};

exports.errorNotif = errorNotif;
var errNotif = exports.errNotif = function errNotif(title, content) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

  return (0, _notification_context.addNotif)({
    title: title,
    baseColor: "red",
    content: content,
    duration: duration
  });
};

var successNotif = function successNotif(_ref4) {
  var _ref4$title = _ref4.title,
      title = _ref4$title === undefined ? (0, _bridge.t)("success") : _ref4$title,
      _ref4$duration = _ref4.duration,
      duration = _ref4$duration === undefined ? 3 : _ref4$duration,
      rest = _objectWithoutProperties(_ref4, ["title", "duration"]);

  return (0, _notification_context.addNotif)(_extends({
    title: title,
    baseColor: "green",
    duration: duration
  }, rest));
};

exports.successNotif = successNotif;
var success = exports.success = function success() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _bridge.t)("saved");
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return (0, _notification_context.addNotif)({
    title: title,
    baseColor: "green",
    icon: "checked",
    small: true,
    position: "center",
    duration: duration
  });
};

var unknownError = exports.unknownError = function unknownError() {
  return errNotif((0, _bridge.t)("oops"), (0, _bridge.t)("unknownError"));
};

// LEGACY

var openNotif = exports.openNotif = function openNotif(title) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "info";
  var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  notify({
    type: type,
    title: title,
    content: content,
    duration: 3.5
  });
};